// Event utility functions

export const getEventStatusInfo = (event) => {
  if (!event) return { status: 'Unknown', color: 'gray' };
  
  // Use the eventStatus directly from the API response
  const status = event.eventStatus || 'Upcoming';
  
  switch (status) {
    case 'In Progress':
      return {
        status: 'In Progress',
        color: 'yellow',
        bgColor: 'bg-yellow-100',
        textColor: 'text-yellow-800',
        dotColor: 'bg-yellow-500'
      };
    case 'Completed':
      return {
        status: 'Completed',
        color: 'green',
        bgColor: 'bg-green-100',
        textColor: 'text-green-800',
        dotColor: 'bg-green-500'
      };
    case 'Upcoming':
    default:
      return {
        status: 'Upcoming',
        color: 'blue',
        bgColor: 'bg-blue-100',
        textColor: 'text-blue-800',
        dotColor: 'bg-blue-500'
      };
  }
};

export const getEventTypeInfo = (event) => {
  if (!event) return { icon: null, color: 'text-gray-600', bgColor: 'bg-gray-100' };
  
  switch (event.eventType) {
    case 'Match':
      return {
        icon: (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        ),
        color: 'text-red-600',
        bgColor: 'bg-red-100'
      };
    case 'Training':
      return {
        icon: (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 7.172V5L8 4z" />
          </svg>
        ),
        color: 'text-blue-600',
        bgColor: 'bg-blue-100'
      };
    default:
      return {
        icon: (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        ),
        color: 'text-purple-600',
        bgColor: 'bg-purple-100'
      };
  }
};

export const getAttendanceStatusInfo = (event) => {
  const status = event?.userAttendanceStatus;
  
  if (!status || status === 'pending') {
    return {
      status: 'No Response',
      color: 'text-gray-600',
      bgColor: 'bg-gray-100'
    };
  }

  switch (status) {
    case 'attended':
    case 'going':
    case 'coming':
      return {
        status: status === 'attended' ? 'Attended' : 'Going',
        color: 'text-green-600',
        bgColor: 'bg-green-100'
      };
    case 'absent':
    case 'not_going':
    case 'notComing':
      return {
        status: status === 'absent' ? 'Absent' : 'Not Going',
        color: 'text-red-600',
        bgColor: 'bg-red-100'
      };
    case 'maybe':
    case 'doNotKnow':
      return {
        status: 'Maybe',
        color: 'text-yellow-600',
        bgColor: 'bg-yellow-100'
      };
    default:
      return {
        status: 'No Response',
        color: 'text-gray-600',
        bgColor: 'bg-gray-100'
      };
  }
}; 